// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_defined.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_defined.js
// module chunks = 168707334958949